module.exports = __webpack_public_path__ + "img/1.b40711fb.jpg";